export const BRAND_LOGO_URL =
  "https://assets.codemonday.io/codemonday-logo-512.png";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`}>
      <img alt="" className="brand__logo" src={BRAND_LOGO_URL} />
      <span>
        <strong>CODEMONDAY</strong>
        {!compact && <small>Identity</small>}
      </span>
    </div>
  );
}
